var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9697 7.46967C13.2626 7.17678 13.7374 7.17678 14.0303 7.46967L18.0303 11.4697C18.3232 11.7626 18.3232 12.2374 18.0303 12.5303L14.0303 16.5303C13.7374 16.8232 13.2626 16.8232 12.9697 16.5303C12.6768 16.2374 12.6768 15.7626 12.9697 15.4697L16.4393 12L12.9697 8.53033C12.6768 8.23744 12.6768 7.76256 12.9697 7.46967Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L12.0303 11.4697C12.3232 11.7626 12.3232 12.2374 12.0303 12.5303L7.03033 17.5303C6.73744 17.8232 6.26256 17.8232 5.96967 17.5303C5.67678 17.2374 5.67678 16.7626 5.96967 16.4697L10.4393 12L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRight);
export default __webpack_public_path__ + "static/media/double-right.d1e5eebdb89f34dd466d6bf4917e52ca.svg";
export { ForwardRef as ReactComponent };